define('common/views/confirmation_popup',['require','exports','module','./modal_view','ldsh!../templates/confirmation_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require('./modal_view');

  module.exports = ModalView.extend({
    template: require('ldsh!../templates/confirmation_popup'),

    triggers: {
      'click .js-ok': 'ok',
      'click .js-cancel': 'cancel'
    },

    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(textResources) {
      var popup = new module.exports({
          model: new Backbone.Model(this.getTextResources(textResources))
      }),
          defer = $.Deferred();

      popup.on('ok', _.bind(defer.resolve, defer));
      popup.on('cancel', _.bind(defer.reject, defer));

      defer.always(_.bind(popup.hide, popup));

      return defer.promise();
    },

    getTextResources: function (textResources) {
      textResources || ( textResources = {});
      textResources.okButton || (textResources.okButton = 'common.deleteButton');
      textResources.koButton || (textResources.koButton = 'common.cancelButton');

      return textResources;
    }
  });
});


